import { render, staticRenderFns } from "./HeaderNotifications.vue?vue&type=template&id=2be1ca85"
import script from "./HeaderNotifications.vue?vue&type=script&lang=js"
export * from "./HeaderNotifications.vue?vue&type=script&lang=js"
import style0 from "./HeaderNotifications.vue?vue&type=style&index=0&id=2be1ca85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports